import React from "react";
import "./StaticPage.css";

export default function TermsOfUse() {
  return (
    <div className="static-page">
      <div className="static-container">
        <span className="section-label">Legal</span>
        <h1>Terms of Use</h1>
        <p className="static-intro">
          Welcome to PureJar. By using our website and placing orders, you agree to these terms.
          Please read them carefully. Last updated: July 2026.
        </p>

        <section>
          <h2>About Us</h2>
          <p>
            PureJar is a brand owned and operated by Neoteric Roots Private Limited
            (CIN: U82990UT2023PTC016158), a company registered in Uttarakhand, India.
            We sell authentic food products online at purejar.in.
          </p>
        </section>

        <section>
          <h2>Placing an Order</h2>
          <ul>
            <li>All orders are subject to product availability and confirmation of payment.</li>
            <li>Prices are listed in Indian Rupees (INR) and include applicable taxes unless stated otherwise.</li>
            <li>We reserve the right to refuse or cancel any order at our discretion, including in cases of suspected fraud or pricing errors.</li>
            <li>Once payment is confirmed, you'll receive an order confirmation email with an invoice.</li>
          </ul>
        </section>

        <section>
          <h2>Pricing and Payment</h2>
          <p>
            We accept payments through Razorpay (UPI, cards, net banking, wallets) and Cash on Delivery
            (a ₹49 handling fee applies to COD orders). All prices are subject to change without notice,
            but changes will not affect orders already confirmed.
          </p>
        </section>

        <section>
          <h2>Shipping and Delivery</h2>
          <p>
            We ship pan-India through Shiprocket and its courier partners. Delivery timelines are estimates
            and may vary based on location and external factors. See our Shipping Policy for details.
          </p>
        </section>

        <section>
          <h2>Returns and Refunds</h2>
          <p>
            Returns are accepted within 2 days of delivery for eligible products. Please see our
            Return &amp; Refund Policy for full details on eligibility and the process.
          </p>
        </section>

        <section>
          <h2>Product Information</h2>
          <p>
            We make every effort to display our products and their details accurately. However, natural
            products may vary slightly in colour, texture, and taste from batch to batch — this is a sign
            of authenticity, not a defect.
          </p>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            All content on this website — including the PureJar name, logo, product photography, and text —
            is the property of Neoteric Roots Private Limited and may not be used without our written permission.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            PureJar is not liable for any indirect or consequential damages arising from the use of our
            products or website. Our maximum liability is limited to the value of the product purchased.
          </p>
        </section>

        <section>
          <h2>Governing Law</h2>
          <p>
            These terms are governed by the laws of India. Any disputes will be subject to the jurisdiction
            of the courts in Nainital, Uttarakhand.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Questions about these terms? Email us at <a href="mailto:wecare@purejar.in">wecare@purejar.in</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
